import Typography from '@material-ui/core/Typography';
import { format } from 'date-fns';
import cloneDeep from 'lodash/cloneDeep';
import React from 'react';

import {
  states,
  INQUIRY_FORM_REQUEST_TYPES,
  PAYMENT_TYPES,
} from 'src/components/forms/schemas/definitions';
import v100Schema from 'src/components/forms/schemas/eventResult/inquiryFormDetails/1.0.0';
import Documents from 'src/components/general/documents';
import { parseUnknownDate } from 'src/util/parseUnknownDate';

const DateTime = ({ model, key }) => (
  <>
    {model[key] && (
      <Typography variant="body1">
        {format(parseUnknownDate(model[key]), 'eee, MMM d, yyyy p z')}
      </Typography>
    )}
  </>
);

// Reorder Inquiry: Form Details properties.
const v110Schema = cloneDeep(v100Schema);
delete v110Schema.properties;

export default {
  ...v110Schema,
  properties: {
    formSubmissionTime: {
      type: 'string',
      renderer: {
        component: DateTime,
      },
    },
    requestType: {
      type: 'string',
      enum: INQUIRY_FORM_REQUEST_TYPES,
    },
    treatmentType: {
      type: 'string',
    },
    requestedVisitTime: {
      type: 'string',
      renderer: {
        component: DateTime,
      },
    },
    caseRatePayor: {
      type: 'string',
      renderer: {
        component: ({ model }) => model.caseRatePayor === 'true' && <>Yes - Offer Drop In Intake</>,
      },
    },
    firstName: {
      type: 'string',
    },
    preferredName: {
      type: 'string',
    },
    lastName: {
      type: 'string',
    },
    pronouns: {
      type: 'string',
    },
    gender: {
      type: 'string',
    },
    genderDiffersFromID: {
      type: 'boolean',
    },
    birthdate: {
      type: 'string',
    },
    phoneNumber: {
      type: 'string',
      format: 'phone',
    },
    email: {
      type: 'string',
      format: 'email',
    },
    communicationOptIn: {
      type: 'string',
    },
    streetAddress: {
      type: 'string',
    },
    city: {
      type: 'string',
    },
    homeState: {
      type: 'string',
    },
    zip: {
      type: 'string',
    },
    differentMailingaddress: {
      type: 'string',
    },
    mailingStreetAddress: {
      type: 'string',
    },
    mailingCity: {
      type: 'string',
    },
    mailingState: {
      type: 'string',
    },
    mailingZip: {
      type: 'string',
    },
    currentlyHouseless: {
      type: 'string',
    },
    state: {
      type: 'string',
      enum: states,
    },
    treatmentInfo: {
      type: 'string',
    },
    npi: {
      type: 'string',
    },
    boulderCarePgNpi: {
      type: 'string',
    },
    insuranceType: {
      type: 'string',
      enum: ['Commercial', 'Medicare/Medicaid', 'Uninsured', 'Selfpay'],
    },
    paymentType: {
      type: 'string',
      renderer: {
        component: ({ model }) => model.paymentType && <>{PAYMENT_TYPES[model.paymentType]}</>,
      },
    },
    paymentMethod: {
      type: 'string',
      renderer: {
        component: ({ model }) => {
          const { paymentMethod } = model;
          if (!paymentMethod) return null;
          return <>{paymentMethod === 'insurance' ? 'Insurance' : 'Self Pay'}</>;
        },
      },
    },
    payorName: {
      type: 'string',
      dependsOn: 'paymentMethod',
      displayOnDependent: paymentMethod => paymentMethod === 'insurance',
    },
    potentialParticipantsRelationshipToInsuranceHolder: {
      type: 'string',
    },
    formDocuments: {
      type: 'array',
      title: 'Attached Files',
      displayOnly: true,
      renderer: {
        component: ({ model }) => {
          if (!model.formDocuments) {
            return null;
          }
          return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <Documents documents={model.formDocuments} />
            </ul>
          );
        },
      },
    },
    pharmacyName: {
      type: 'string',
    },
    pharmacyAddress: {
      type: 'string',
    },
    goals: {
      type: 'string',
      uniforms: {
        multiline: true,
      },
    },
    referralCode: {
      type: 'string',
    },
    referralSourceType: {
      type: 'string',
    },
    referrerFirstName: {
      type: 'string',
    },
    referrerLastName: {
      type: 'string',
    },
    referrerPracticeName: {
      type: 'string',
    },
    referrerPhoneNumber: {
      type: 'string',
      format: 'phone',
    },
    interestFromParticipant: {
      type: 'string',
    },
    relationshipToParticipant: {
      type: 'string',
    },
    otherTreatment: {
      type: 'string',
    },
    additional: {
      type: 'string',
      uniforms: {
        multiline: true,
      },
    },
    utm_medium: {
      type: 'string',
    },
    utm_source: {
      type: 'string',
    },
    utm_campaign: {
      type: 'string',
    },
    utm_content: {
      type: 'string',
    },
    utm_term: {
      type: 'string',
    },
    session_id: {
      type: 'string',
    },
    user_id: {
      type: 'string',
    },
  },
};
